export default function AtasRegistroPreco() {
    return (<></>
        // <div className="container mt-4">
        //     <p><small>Você está em <a href="/prestacao-de-contas">Prestação de Contas</a> / Atas de Registro de Preço</small></p>
        //     <h1 className="mb-4">Atas de Registro de Preço</h1>
        //     <p>No momento, não há registro de Atas de Registro de Preço elaboradas pela ALEPE.</p>
        // </div>
    );
}
